import { Menu } from 'lucide-react';
import { ConnectionPill } from '@/components/layout/connection-pill';
import { GlobalSearch } from '@/components/layout/global-search';
import { NotificationBell } from '@/components/layout/notification-bell';
import { UserMenu } from '@/components/layout/user-menu';
import { Button } from '@/components/ui/button';
import { CompanySwitcher } from '@/components/layout/company-switcher';

/**
 * Slim bar above the content column. Deliberately holds no navigation — the
 * sidebar owns that — so it stays a row of tools: search, live-feed health,
 * notifications and the account menu.
 */
export function TopBar({ onOpenSidebar }: { onOpenSidebar: () => void }) {
  return (
    <header className="relative z-30 flex h-16 shrink-0 items-center gap-3 border-b bg-card px-4 sm:px-5">
      <Button
        variant="ghost"
        size="icon"
        className="size-9 lg:hidden"
        onClick={onOpenSidebar}
        aria-label="Open navigation"
      >
        <Menu className="size-4.5" />
      </Button>

      <div className="ml-auto flex items-center gap-2 sm:gap-2.5">
        {/* Renders only for the platform owner. */}
        <CompanySwitcher />
        <div className="hidden sm:block">
          <GlobalSearch />
        </div>
        <ConnectionPill className="hidden lg:flex" />
        <NotificationBell />
        <div className="mx-0.5 hidden h-6 w-px bg-border sm:block" />
        <UserMenu />
      </div>
    </header>
  );
}
